export default "__VITE_ASSET__519a8f6c__"